import { forwardRef } from 'react';

import MuiFormGroup from '@mui/material/FormGroup';
const FormGroup = forwardRef((props, ref) => {
  return <MuiFormGroup ref={ref} {...props} />;
});
FormGroup.displayName = 'FormGroup';
export default FormGroup;
